import { Model } from 'modules/core/lib/mobx-rest'

interface IAudit {
  [key: string]: any
}

class Audit extends Model<IAudit> {
  static urlRoot() {
    return '/audit_log/audits'
  }
}

export default Audit
